export default "__VITE_ASSET__1c5d2847__"